const HOT = [
  "街头搭讪被怼",
  "地铁偶遇翻车",
  "咖啡店直球名场面",
  "相亲局社死",
  "网络奔现翻车",
  "酒局壮胆搭讪",
];

export default function Hero() {
  return (
    <section id="home" className="relative w-full overflow-hidden">
      <div className="relative flex min-h-[520px] w-full items-center justify-center md:min-h-[620px]">
        <img
          src="https://readdy.ai/api/search-image?query=playful%20flat%20cartoon%20illustration%20of%20a%20young%20man%20doing%20an%20awkward%20flirtation%20attempt%20with%20speech%20bubbles%20showing%20funny%20exclamations%2C%20surprised%20faces%2C%20zany%20city%20street%20scene%20with%20trees%20and%20shops%2C%20vibrant%20warm%20orange%20amber%20and%20cream%20color%20palette%2C%20soft%20teal%20accents%2C%20humorous%20meme%20comic%20book%20style%2C%20clean%20vector%20graphics%2C%20bright%20cheerful%20atmosphere%20with%20lots%20of%20whitespace&width=1600&height=900&seq=hero-banner-2026&orientation=landscape"
          alt="搭讪翻车现场的卡通插画背景"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-orange-50" />

        <div className="relative z-10 flex w-full flex-col items-center justify-center px-4 py-16 text-center md:px-6 md:py-24">
          <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/40 bg-white/15 px-4 py-1.5 text-xs font-medium text-white backdrop-blur-sm">
            <i className="ri-fire-fill text-amber-300" />
            全网最新搭讪翻车名场面 每日更新
          </span>

          <h1 className="font-hand max-w-4xl text-4xl leading-tight text-white md:text-6xl md:leading-tight">
            围观搭讪名场面 <br className="md:hidden" />
            真实又扎心的翻车现场
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/90 md:text-lg">
            街头搭讪被拒、地铁偶遇翻车、相亲局社死……精选全网最劲爆的搭讪失败合集与被怼视频，一份让你笑到岔气的瓜，拿走不谢。
          </p>

          <div className="mt-9 flex w-full flex-col items-center justify-center gap-3 sm:w-auto sm:flex-row">
            <a
              href="#feed"
              className="w-full whitespace-nowrap rounded-full bg-orange-500 px-8 py-3 text-sm font-semibold text-white transition-colors hover:bg-orange-600 sm:w-auto"
            >
              <i className="ri-play-circle-fill mr-2" />
              开始吃瓜
            </a>
            <a
              href="#top"
              className="w-full whitespace-nowrap rounded-full border border-white/50 bg-white/10 px-8 py-3 text-sm font-semibold text-white backdrop-blur-sm transition-colors hover:bg-white/25 sm:w-auto"
            >
              看今日名场面榜
            </a>
          </div>

          <div className="mt-10 flex items-center gap-8 text-white">
            <div className="text-center">
              <p className="font-hand text-3xl text-amber-300">2.8w+</p>
              <p className="mt-1 text-xs text-white/80">精选视频</p>
            </div>
            <div className="h-10 w-px bg-white/40" />
            <div className="text-center">
              <p className="font-hand text-3xl text-amber-300">4000w+</p>
              <p className="mt-1 text-xs text-white/80">累计播放</p>
            </div>
            <div className="h-10 w-px bg-white/40" />
            <div className="text-center">
              <p className="font-hand text-3xl text-amber-300">98.6%</p>
              <p className="mt-1 text-xs text-white/80">观众嘴角上扬率</p>
            </div>
          </div>
        </div>
      </div>

      <div className="relative mx-auto -mt-2 max-w-7xl px-4 md:px-6">
        <div className="dot-bg flex flex-col gap-3 rounded-2xl border border-stone-200 bg-white/95 p-4 shadow-sm backdrop-blur md:flex-row md:items-center md:gap-4 md:p-5">
          <span className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-stone-800">
            <i className="ri-flashlight-fill text-orange-500" />
            今日吃瓜热点
          </span>
          <div className="no-scrollbar flex flex-wrap items-center gap-2">
            {HOT.map((h) => (
              <span
                key={h}
                className="whitespace-nowrap rounded-full bg-orange-100 px-3 py-1 text-xs font-medium text-orange-700 transition-colors hover:bg-orange-200"
              >
                # {h}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}